var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2997 7.38818H14.9664V9.36617H18.2997C19.2913 9.36617 20.0604 9.87221 20.0604 10.308V19.0794C20.0604 19.5149 19.2913 20.0216 18.2997 20.0216H5.69958C4.70828 20.0216 3.93917 19.5149 3.93917 19.0794V10.309C3.93917 9.87319 4.70828 9.36683 5.69958 9.36683H9.03249V7.38884H5.69958C3.60324 7.38884 1.96118 8.67157 1.96118 10.309V19.0797C1.96118 20.7175 3.60324 21.9996 5.69958 21.9996H18.3003C20.396 21.9996 22.0387 20.7168 22.0387 19.0797V10.309C22.0384 8.67091 20.3964 7.38818 18.2997 7.38818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9924 11.5225C14.8625 11.5224 14.7339 11.548 14.6139 11.5978C14.4939 11.6476 14.3849 11.7206 14.2932 11.8126L13.055 13.0505V2.98851C13.055 2.72621 12.9508 2.47465 12.7653 2.28918C12.5799 2.10371 12.3283 1.99951 12.066 1.99951C11.8037 1.99951 11.5521 2.10371 11.3667 2.28918C11.1812 2.47465 11.077 2.72621 11.077 2.98851V13.1171L9.77186 11.8123C9.68021 11.7202 9.57125 11.6471 9.45126 11.5972C9.33126 11.5473 9.20259 11.5216 9.07265 11.5216C8.9427 11.5216 8.81403 11.5473 8.69403 11.5972C8.57404 11.6471 8.46508 11.7202 8.37343 11.8123C8.28155 11.9041 8.20867 12.013 8.15894 12.133C8.10921 12.2529 8.08362 12.3815 8.08362 12.5114C8.08362 12.6412 8.10921 12.7698 8.15894 12.8897C8.20867 13.0097 8.28155 13.1187 8.37343 13.2104L11.3262 16.1632C11.4179 16.2551 11.5269 16.3279 11.6468 16.3775C11.7668 16.4271 11.8953 16.4526 12.0251 16.4523H12.04C12.2931 16.4523 12.5457 16.3564 12.7388 16.1632L15.6916 13.2104C15.8303 13.0723 15.9248 12.8961 15.9631 12.7041C16.0015 12.5122 15.982 12.3132 15.9071 12.1324C15.8322 11.9516 15.7052 11.7971 15.5424 11.6885C15.3796 11.5799 15.1881 11.5222 14.9924 11.5225Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.42a7a4960ef0a6e3c70ed317784ebe4f.svg";
export { ForwardRef as ReactComponent };